<template>
    <div
        :data-component="$options.name"
        class="z-debug relative"
    >
        <cs-modal
            :visible="isVisible"
            :headerText="'Impressum'"
            :contentRendered="isVisible"
            @update:visible="emitClosedModalEvent"
        >
            <p class="text-text-l whitespace-pre-line">{{ imprint }}</p>
        </cs-modal>
    </div>
</template>
<script lang="ts" src="./MsDetailModalImprint.ts" />
